// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"62a5a2d2","65":"5ae94638","196":"6534f7be","246":"f8fa65ea","391":"a42f3857","395":"c02abb66","454":"63c1f715","574":"6fae951e","609":"65dbe9ee","875":"8fd458da","888":"d0b76450","929":"c2439796"}[chunkId] + ".chunk.js";
};